export const PLAN_QUESTION_LIST = () => [
  {
    title: t("WhatDoesQuotaMean"),
    list: [t("ReturnRequest1Quota"), t("WhenMerchantsManageReturnRequestsTh")],
  },
  {
    title: t("WhatDoesFreeReturnServiceSalesMean"),
    list: [t("ReturnProtectionSalesFaqAnswer")],
  },
  {
    title: t("HowAboutTheFreeTrial"),
    list: [
      t("SubscriptionPlanWillHaveA_7DayFree", {
        replace: {
          days: 7,
        },
      }),
      t("DuringFreeTrialAccessAllFeatures"),
      t("AfterTrialEndsChoosePlan"),
    ],
  },
  {
    title: t("CanIChangeMyPlanInTheMiddleOfTh"),
    jumpUrl:
      "https://help.shopify.com/en/manual/your-account/manage-billing/your-invoice/apps#app-prorating-upgrades-downgrades",
    list: [
      t("UpgradingYourPlanTakesEffectImmedia"),
      t("DowngradingYourPlanWillTakeEffectA"),
    ],
  },
]

export const PLAN_LIST_MAP = () => ({
  1: {
    enName: t("Free"),
    planText: t("Free"),
    planDesc: t("ForANewBusiness"),
    additionalText: t("FreePlanFeaturesIncludedAre"),
    list: [
      {
        text: t("SmartReturnManagement"),
      },
      {
        text: t("BrandedReturnPage"),
      },
      {
        text: t("ReturnLabel"),
      },
      {
        text: t("CustomReturnReasons"),
      },
      {
        text: t("CustomerAccountWidget"),
      },
      {
        text: t("ReplaceAndExchangeItem"),
        withoutFeature: true,
      },
      {
        text: t("AutomationAndWorkflows"),
        withoutFeature: true,
      },
      {
        text: t("RestockingAndShippingFees"),
        withoutFeature: true,
      },
      {
        text: t("AndMore"),
        withoutFeature: true,
      },
    ],
  },
  2: {
    enName: t("Essential"),
    additionalText: t("AllFreeFeaturesPlus"),
    planText: t("Essential"),
    planDesc: t("ForGrowingBrands"),
    list: [
      {
        text: t("AlternativeRefunds"),
      },
      {
        text: t("ReplaceItem"),
      },
      {
        text: t("GreenReturn"),
      },
      {
        text: t("BlockRules"),
      },
      {
        text: t("RestockingAndShippingFees"),
      },
      {
        text: t("ReturnRewards"),
      },
      {
        text: t("MultiLanguage"),
      },
      {
        text: t("ReturnProtection"),
        id: "freeReturnServiceWidget",
      },
      {
        text: t("EmailNotifications"),
      },
    ],
  },
  3: {
    enName: t("Professional"),
    additionalText: t("AllEssentialFeaturesPlus"),
    planText: t("Professional"),
    planDesc: t("ForSmarterReturnOperations"),
    list: [
      {
        text: t("ExchangeForDifferentItems"),
      },
      {
        text: t("StoreCreditRefunds"),
      },
      {
        text: t("AutoApprove"),
      },
      {
        text: t("AutoExchange"),
      },
      {
        text: t("ReturnShipmentAutotrack"),
      },
      {
        text: t("ConnectYourOwnCarriers"),
      },
      {
        text: t("ReturnsDataExport"),
      },
      {
        text: t("OnboardingMeeting"),
      },
      {
        text: t("LiveSupport", {
          replace: {
            hours: 24,
            days: 7,
          },
        }),
      },
    ],
  },
  4: {
    enName: t("Enterprise"),
    additionalText: t("AllProfessionalFeaturesPlus"),
    planText: t("Enterprise"),
    planDesc: t("ForComplexBusinesses"),
    list: [
      {
        text: t("ReturnsWebhooks"),
      },
      {
        text: t("CustomIntegrations"),
      },
      {
        text: t("PrioritySupport"),
      },
      {
        text: t("SuccessManager"),
      },
    ],
  },
})
